<div class="swap-approval-container">
  <div class="swap-approval-content">
    <!-- Header -->
    <div class="swap-header">
      <h2>Review Swap</h2>
      <p>Please review the details below before proceeding.</p>
    </div>

    <!-- Token Swap Card -->
    <div class="swap-tokens-card">
      <!-- From Token -->
      <div class="token-row sell">
        <div class="token-info">
          <kc-token-logo
            [ticker]="fromToken().symbol"
            [address]="fromToken().address"
            size="lg"
          />
          <div class="token-details">
            <span class="token-label">Sell</span>
            <span class="token-symbol">{{ fromToken().symbol }}</span>
          </div>
        </div>
        <div class="token-amount">
          <span class="amount-value">{{ fromAmount() | commaFormatter }}</span>
        </div>
      </div>

      <!-- Arrow -->
      <div class="swap-arrow">
        <kc-icon iconClass="icon-arrow-down" size="sm" />
      </div>

      <!-- To Token -->
      <div class="token-row buy">
        <div class="token-info">
          <kc-token-logo
            [ticker]="toToken().symbol"
            [address]="toToken().address"
            size="lg"
          />
          <div class="token-details">
            <span class="token-label">Buy</span>
            <span class="token-symbol">{{ toToken().symbol }}</span>
          </div>
        </div>
        <div class="token-amount">
          <span class="amount-value">{{ toAmount() | commaFormatter }}</span>
        </div>
      </div>
    </div>

    <!-- Swap Details Card -->
    <div class="swap-details-card">
      <!-- Order Routing -->
      <div class="detail-row">
        <span class="detail-label">Order Routing</span>
        <span class="detail-value">{{ route() }}</span>
      </div>

      <!-- Min Received -->
      <div class="detail-row">
        <span class="detail-label">Min Received</span>
        <span class="detail-value"
          >{{ minReceived() | commaFormatter }} {{ toToken().symbol }}</span
        >
      </div>

      <!-- Price Impact -->
      <div class="detail-row">
        <span class="detail-label">Price Impact</span>
        <span
          class="detail-value"
          [class.warning]="priceImpact() !== '0' && +priceImpact() > 3"
          >{{ priceImpact() }}%</span
        >
      </div>

      <!-- Max Slippage -->
      <div class="detail-row">
        <span class="detail-label">Max Slippage</span>
        <span class="detail-value">{{ slippage() }}%</span>
      </div>

      <!-- Transaction Deadline -->
      <div class="detail-row">
        <span class="detail-label">Deadline</span>
        <span class="detail-value">{{ deadline() }} min</span>
      </div>

      <!-- Network Fees / Estimated Gas -->
      <div class="detail-row">
        <span class="detail-label">Network Cost</span>
        <span class="detail-value">{{ estimatedGas() }}</span>
      </div>

      <!-- Network -->
      <div class="detail-row">
        <span class="detail-label">Network</span>
        <span class="detail-value">{{ networkName() }}</span>
      </div>
    </div>

    <ng-content />

    <!-- Action Buttons -->
    <div class="action-buttons-section">
      <div class="action-buttons">
        <kc-button
          [text]="isLoading() ? 'Processing...' : 'Approve Swap'"
          variant="primary"
          size="m"
          [isFullWidth]="true"
          [isDisabled]="isLoading() || !canApprove()"
          [isLoading]="isLoading()"
          (buttonClick)="onApprove()"
        />

        <kc-button
          text="Reject"
          variant="secondary"
          size="m"
          [isFullWidth]="true"
          [isDisabled]="isLoading()"
          (buttonClick)="onReject()"
        />
      </div>
    </div>
  </div>
</div>
